import React from 'react';
export function CreditCardIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M19 14h-5v2h5v-2z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 19a1 1 0 001 1h20a1 1 0 001-1V5a1 1 0 00-1-1H2a1 1 0 00-1 1v14zM3 6v2h18V6H3zm18 5H3v7h18v-7z"
  }));
}